import ReactGA from 'react-ga'

const isLocal = process.env.SERVER === 'local' || process.env.WEBPACK_FILE === 'local'

const showConsole = (category, action, data, people = undefined, error = undefined) => {
  if (console.groupCollapsed) {
    console.groupCollapsed('[GA]:', category)
  }
  if (error) {
    console.log('error:', error)
  }
  if (console.groupCollapsed) {
    console.groupEnd()
  }
}

export const googleTrack = (category, action, data, people = undefined) => {
  if (!isLocal) {
    try {
      ReactGA.event({
        category,
        action,
        label: JSON.stringify(people),
      })
    } catch (err) {
      showConsole(category, action, data, people, err)
    }
  } else {
    showConsole(category, action, data, people)
  }
}

export const googleException = ({ fatal, description }) => {
  const data = {
    exDescription: JSON.stringify(description),
    exFatal: fatal,
  }
  if (!isLocal) {
    try {
      ReactGA.exception(data)
    } catch (err) {
      showConsole('googleException', 'exception', data, undefined, err)
    }
  } else {
    showConsole('googleException', 'exception', data)
  }
}

export const googleIdentify = (id = 'NOT SET', people = 'empty') => {
  if (!isLocal) {
    try {
      ReactGA.set({
        userId: id,
        people,
      })
    } catch (err) {
      showConsole('googleIdentify', 'identify', id, people, err)
    }
  } else {
    showConsole('googleIdentify', 'identify', id, people)
  }
}

export const googlePageview = pathname => {
  if (!isLocal) {
    try {
      ReactGA.pageview(pathname)
    } catch (err) {
      showConsole('googlePageview', 'pageview', pathname, undefined, err)
    }
  } else {
    showConsole('googlePageview', 'pageview', pathname)
  }
}
